import type { DataContainer } from "@otto-ec/tracking-bct";
import { toggle } from "../../../exports/toggle";
import { getScreenSpecs, type } from "../../../exports/device";
import { addLabels } from "../../../exports/apm";

/*                     */
/**
 *
 */
export const dataContainer: DataContainer = {};

/**
 *
 */
export function getPreferredContrast(): "more" | "less" | "custom" | null {
  if (window.matchMedia("(prefers-contrast: more)").matches) return "more";
  if (window.matchMedia("(prefers-contrast: less)").matches) return "less";
  if (window.matchMedia("(prefers-contrast: custom)").matches) return "custom";
  return null;
}

/**
 *
 */
export function getPreferredColorScheme(): "dark" | "light" {
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
}

/**
 *
 */
export function trackDevicePreferences(): void {
  if (!toggle.get("gr_track_device_preferences", false)) return;

  dataContainer.ot_PreferredColorScheme = [getPreferredColorScheme()];

  const contrastLevel = getPreferredContrast();
  if (contrastLevel) {
    dataContainer.ot_PreferredContrast = [contrastLevel];
  }
}

/**
 *
 */
export function trackDeviceTextSize(): void {
  if (!toggle.get("gr_track_device_text_size", false)) return;
  const fontSize = window.getComputedStyle(document.documentElement).fontSize || "unknown";
  dataContainer.ot_TextSize = [fontSize];
}

export async function trackDevicePixelRatio(): Promise<void> {
  if (!toggle.get("gr_track_device_pixel_ratio", false)) return;

  const specs = await getScreenSpecs();
  dataContainer.ot_DevicePixelRatio = [`${specs.pixelRatio}`];
}

/**
 *
 */
export function submitPageImpression(): Promise<void> | void {
  if (Object.keys(dataContainer).length === 0) return;
  return otto.tracking.submitMerge(dataContainer);
}

export function addDeviceSpecsToApm(): void {
  addLabels({ device_class: type });
}
